import React from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function Sidebar({ isOpen, onClose }) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.profile);
  return (
    <div
      className={`fixed top-0 left-0 h-full w-64 bg-[#00254D] text-white shadow-lg z-50 transform transition-transform duration-300 ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="flex items-center justify-between p-4 border-b border-gray-700">
        <h2 className="text-lg font-bold"> </h2>
        <button onClick={onClose} aria-label="Close Sidebar">
          <X className="w-6 h-6" />
        </button>
      </div>

      <div className="p-4">
        <ul className="space-y-4">
          <li className="hover:text-[#a3b4ff] cursor-pointer">
            <Link to="/dashboard" onClick={onClose}>
              {t("sidebar.dashboard")}
            </Link>
          </li>
          <li className="hover:text-[#a3b4ff] cursor-pointer">
            <Link to="/dashboard/profile" onClick={onClose}>
              {t("sidebar.myProfile")}
            </Link>
          </li>
          {user?.role === "student" && (
            <>
              {" "}
              <li className="hover:text-[#a3b4ff] cursor-pointer">
                <Link to="/dashboard/student/assessment" onClick={onClose}>
                  {t("sidebar.assessmentForm")}
                </Link>
              </li>
              <li className="hover:text-[#a3b4ff] cursor-pointer">
                <Link
                  to="/dashboard/student/curriculum-request"
                  onClick={onClose}
                >
                  {t("sidebar.request")}
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
}
